// Task duration helpers shared by the daily view (PlanDayOrder "סה״כ זמן"), the
// memberships tab's selection total and DialogPlaceInPlan — one format everywhere.

// Sum of durationMinutes; a task with no duration adds 0.
const totalMinutes = (tasks) => tasks.reduce((a, t) => a + (t.durationMinutes || 0), 0);

// Minutes -> "H:MM" ("00:MM" under an hour).
const toHours = (minutes) => {
  if (minutes == null) return "—";
  const h = Math.floor(minutes / 60);
  const m = Math.round(minutes % 60);
  const mm = m < 10 ? `0${m}` : m;
  if (h === 0) return `00:${mm}`;
  return `${h}:${mm}`;
};

export default { totalMinutes, toHours };
